import { memo, ReactNode } from "react";
import { Tabs, TabsProps } from "@mui/joy";

/**
 * Props for Tabs Component.
 * Extends `TabsProps` from MUI Joy to include all standard Tabs properties.
 */
interface TabsComponentProps extends TabsProps {
  /**
   * Children Component (`ReactNode`).
   */
  children: ReactNode;
}

/**
 * Memoized Tabs Component.
 */
const TabsComponent: React.NamedExoticComponent<TabsComponentProps> = memo(
  function TabsComponent(props: TabsComponentProps): JSX.Element {
    const { children, ...restProps } = props;

    return (
      <Tabs
        className="bg-white"
        {...restProps}
        sx={{
          "& .MuiTab-root.MuiTab-horizontal.MuiTab-variantPlain.MuiTab-colorNeutral.Mui-selected":
            { backgroundColor: "white", color: "#DA291C" },
          "& .MuiTab-root.MuiTab-horizontal.MuiTab-variantPlain.MuiTab-colorNeutral":
            { backgroundColor: "white", color: "#9B9B9B" },
        }}
      >
        {children}
      </Tabs>
    );
  }
);

export default TabsComponent;
